"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Memory = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_bootstrap_1 = require("react-bootstrap");
const values_1 = __importDefault(require("../values"));
const Sprite_1 = require("./Sprite");
const react_1 = require("react");
const minigame_1 = require("../typeDefs/minigame");
const lodash_1 = __importDefault(require("lodash"));
require("./MemoryGame.scss");
const useImages_1 = require("../useImages");
const oink_mp3_1 = __importDefault(require("../sounds/oink.mp3"));
const OINK = new Audio(oink_mp3_1.default);
function Memory({ onCancel, onSolve, giftRepr, difficulty, }) {
    const [hasBeenSolved, setHasBeenSolved] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal, { onHide: onCancel, show: true, size: 'lg', children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Header, { closeButton: true, children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Title, { children: "Memory" }) }), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal.Body, { children: [giftRepr && ((0, jsx_runtime_1.jsxs)("span", { children: ["Play to win: ", giftRepr] })), (0, jsx_runtime_1.jsx)(MemoryGame, { onWin: () => setHasBeenSolved(true), difficulty: difficulty })] }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Footer, { children: hasBeenSolved && ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.Button, { variant: 'primary', onClick: onSolve, children: ["Redeem Gift: ", giftRepr] })) })] }));
}
exports.Memory = Memory;
function MemoryGame({ onWin, difficulty, }) {
    const pairCount = (0, react_1.useMemo)(() => diffToPairCount(difficulty), [difficulty]);
    const missCount = (0, react_1.useMemo)(() => diffToMissCount(difficulty), [difficulty]);
    const dupes = (0, react_1.useMemo)(() => diffToDupes(difficulty), [difficulty]);
    const board = (0, react_1.useMemo)(() => generateBoard(pairCount, dupes), [dupes]);
    const cardFronts = (0, react_1.useMemo)(() => generateCardFronts(board, difficulty), [board.length, difficulty]);
    const [selected, setSelected] = (0, react_1.useState)([]);
    const [allFlipped, setAllFlipped] = (0, react_1.useState)([]);
    const [score, setScore] = (0, react_1.useState)(0);
    const [misses, setMisses] = (0, react_1.useState)(0);
    const [oinkedTimes, setOinkedTimes] = (0, react_1.useState)(0);
    const canClickRef = (0, react_1.useRef)(true);
    const onSelect = (0, react_1.useCallback)((id) => {
        if (canClickRef.current && !allFlipped.includes(id)) {
            setSelected(lodash_1.default.uniq(lodash_1.default.concat(selected, [id])));
            if (misses >= missCount && oinkedTimes < 10) {
                OINK.play();
                setOinkedTimes(oinkedTimes + 1);
            }
        }
    }, [selected.length, misses]);
    (0, react_1.useEffect)(() => {
        if (selected.length === dupes) {
            // check if they match
            canClickRef.current = false;
            if (lodash_1.default.uniq(selected.map(i => board[i])).length === 1) {
                // they all match
                setTimeout(() => {
                    setScore(score + 1);
                    setSelected([]);
                    setAllFlipped(lodash_1.default.concat(selected, allFlipped));
                    canClickRef.current = true;
                }, 500);
            }
            else {
                // they don't match
                setTimeout(() => {
                    setMisses(misses + 1);
                    setSelected([]);
                    canClickRef.current = true;
                }, 500);
            }
        }
    }, [selected, score]);
    (0, react_1.useEffect)(() => {
        if (score === pairCount) {
            onWin();
        }
    }, [score, onWin]);
    const rows = lodash_1.default.chunk(board.map((b, i) => {
        return ((0, jsx_runtime_1.jsx)(FlipCard, { name: b, flipped: selected.includes(i) || allFlipped.includes(i), id: i, onClick: onSelect, front: cardFronts[i] }, i));
    }), Math.sqrt(board.length));
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("hr", {}), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Row, { children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Col, { children: (0, jsx_runtime_1.jsxs)("h3", { children: ["Match ", dupes, "!"] }) }), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Col, { children: [(0, jsx_runtime_1.jsxs)("h4", { children: ["Score: ", score, " / ", pairCount] }), (0, jsx_runtime_1.jsxs)("h4", { children: ["Misses: ", misses, " / ", missCount] })] })] }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Table, { className: 'memorygame noselect', bordered: true, children: (0, jsx_runtime_1.jsx)("tbody", { children: rows.map((row, i) => {
                        return ((0, jsx_runtime_1.jsx)("tr", { children: row.map((item, j) => (0, jsx_runtime_1.jsx)("td", { children: item }, j)) }, i));
                    }) }) })] }));
}
function FlipCard({ name, flipped, front, onClick, id, }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: `flip-card ${flipped ? 'flipped' : ''}`, children: (0, jsx_runtime_1.jsxs)("div", { className: "flip-card-inner", onClick: () => onClick(id), children: [(0, jsx_runtime_1.jsx)("div", { className: "flip-card-front", children: front }), (0, jsx_runtime_1.jsx)("div", { className: "flip-card-back", children: (0, jsx_runtime_1.jsx)(Sprite_1.Sprite, { name: name }) })] }) }));
}
const VALID_GAME_ITEMS = values_1.default.allItemNames.filter(name => {
    if (name.startsWith('research-'))
        return false;
    if (name.startsWith('boost-'))
        return false;
    if (!useImages_1.SPRITES[name])
        return false;
    return true;
});
function generateBoard(n, dupes = 2) {
    const randomItems = lodash_1.default.sampleSize(VALID_GAME_ITEMS, n);
    let total = [];
    for (let i = 0; i < dupes; i++)
        total = lodash_1.default.concat(total, randomItems);
    return lodash_1.default.shuffle(total);
}
function generateCardFronts(board, d) {
    const fronts = [];
    for (let i = 0; i < board.length; i++) {
        switch (d) {
            case minigame_1.Difficulty.Easy: {
                fronts.push((0, jsx_runtime_1.jsx)(Sprite_1.Sprite, { name: 'star' }));
                break;
            }
            case minigame_1.Difficulty.Medium: {
                fronts.push((0, jsx_runtime_1.jsx)(Sprite_1.Sprite, { name: 'star' }));
                break;
            }
            case minigame_1.Difficulty.Hard: {
                fronts.push((0, jsx_runtime_1.jsx)(Sprite_1.Sprite, { name: VALID_GAME_ITEMS[lodash_1.default.random(VALID_GAME_ITEMS.length - 1)] }));
                break;
            }
        }
    }
    return fronts;
}
function diffToDupes(d) {
    switch (d) {
        case minigame_1.Difficulty.Easy: return 2;
        case minigame_1.Difficulty.Medium: return 2;
        case minigame_1.Difficulty.Hard: return 3;
    }
}
function diffToPairCount(d) {
    switch (d) {
        case minigame_1.Difficulty.Easy: return 10;
        case minigame_1.Difficulty.Medium: return 12;
        case minigame_1.Difficulty.Hard: return 12;
    }
}
function diffToMissCount(d) {
    switch (d) {
        case minigame_1.Difficulty.Easy: return 10;
        case minigame_1.Difficulty.Medium: return 12;
        case minigame_1.Difficulty.Hard: return 15;
    }
}
